import { render } from "./product.vue?vue&type=template&id=f9a950fa"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"

import "./product.vue?vue&type=style&index=0&id=f9a950fa&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__